var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTelegramCircle = function SvgTelegramCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_2432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7242 24.0187C19.3568 24.0187 24.7335 18.6419 24.7335 12.0094C24.7335 5.37677 19.3568 0 12.7242 0C6.09161 0 0.714844 5.37677 0.714844 12.0094C0.714844 18.6419 6.09161 24.0187 12.7242 24.0187Z",
    fill: "url(#paint0_linear_363_2432)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13983 11.8789C9.63788 10.345 11.9761 9.35357 13.1546 8.86721C16.4843 7.48296 17.1765 7.23978 17.6254 7.22107C17.7189 7.22107 17.9434 7.23978 18.0931 7.35201C18.2053 7.44554 18.2427 7.57649 18.2614 7.67002C18.2801 7.76355 18.2988 7.96932 18.2801 8.13767C18.0931 10.027 17.3261 14.6474 16.9146 16.7612C16.7462 17.6591 16.4095 17.9584 16.0915 17.9958C15.3994 18.0519 14.8569 17.5282 14.1835 17.0979C13.1359 16.4058 12.5373 15.9756 11.5085 15.3021C10.33 14.5165 11.097 14.0862 11.7704 13.3941C11.9387 13.207 15.0253 10.4198 15.0814 10.1579C15.0814 10.1205 15.1001 10.0083 15.0253 9.95217C14.9504 9.89605 14.8569 9.91476 14.7821 9.93346C14.6698 9.95217 12.9863 11.0745 9.7127 13.2819C9.22634 13.6186 8.7961 13.7682 8.40327 13.7682C7.97303 13.7682 7.14996 13.525 6.53265 13.3193C5.78441 13.0761 5.18581 12.9452 5.24193 12.5336C5.27934 12.3279 5.57864 12.1034 6.13983 11.8789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_363_2432",
    x1: 0.714844,
    y1: 12.0007,
    x2: 24.7162,
    y2: 12.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clip-path", {
    id: "clip0_363_2432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.714844)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTelegramCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram-circle.f74fd6318f39cf4cb9f0026fa6f97342.svg";